(() => {
  let dialog, picture, status;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-crate-proof]');
    if (!link) return;
    event.preventDefault();
    if (!dialog) {
      const style = document.createElement('style');
      style.textContent = '.crate-proof-popup{border:0;border-radius:16px;padding:24px;width:min(900px,94vw);max-height:90dvh;overflow:auto;background:#fff;color:#222}.crate-proof-popup::backdrop{background:rgba(0,0,0,.65)}.crate-proof-popup header{display:flex;align-items:center;justify-content:space-between;gap:16px;margin-bottom:20px}.crate-proof-popup h2{margin:0;font-size:20px}.crate-proof-popup button{min-width:44px;min-height:44px;cursor:pointer;background:#fff;color:#222;border:1px solid #bbb;border-radius:8px;font-size:24px}.crate-proof-popup img{display:block;width:100%;height:auto;max-height:65dvh;object-fit:contain}.crate-proof-popup img[hidden]{display:none}';
      document.head.append(style);
      dialog = document.createElement('dialog');
      dialog.className = 'crate-proof-popup';
      dialog.setAttribute('aria-labelledby', 'crate-proof-heading');
      dialog.innerHTML = '<header><h2 id="crate-proof-heading">Your approved design</h2><button type="button" aria-label="Close preview">×</button></header><p role="status"></p><img alt="Your approved crate tag design" hidden>';
      document.body.append(dialog);
      picture = dialog.querySelector('img');
      status = dialog.querySelector('[role="status"]');
      dialog.querySelector('button').onclick = () => dialog.close();
      dialog.addEventListener('click', (e) => {
        const bounds = dialog.getBoundingClientRect();
        if (e.target === dialog && (e.clientX < bounds.left || e.clientX > bounds.right || e.clientY < bounds.top || e.clientY > bounds.bottom)) dialog.close();
      });
      picture.onload = () => { status.textContent = ''; picture.hidden = false; };
      picture.onerror = () => { status.textContent = 'Your preview could not load. Please close this window and try again.'; picture.hidden = true; };
    }
    status.textContent = 'Loading your design…';
    picture.hidden = true;
    picture.src = link.href;
    dialog.showModal();
  });
})();
